import type { ApiProblem } from '@pos/api-client';
import { problemText } from '@pos/i18n';

/** The part of i18next's t this needs; the full type is too deep to pass around. */
type TFunction = (key: 'admin.errors.forbidden') => unknown;

/** Query and mutation errors from the API clients are problem objects (see crudApi). */
export function asProblem(error: unknown): ApiProblem | null {
  return error ? (error as ApiProblem) : null;
}

/** A translated message for a failed API call. */
export function problemMessage(t: TFunction, problem: ApiProblem | null | undefined): string {
  if (problem?.status === 403 && !problem.code) return String(t('admin.errors.forbidden'));
  return problemText(problem?.code, problem?.title);
}
